import { render } from "./ContactOverlay.vue?vue&type=template&id=a7007144&scoped=true"
import script from "./ContactOverlay.vue?vue&type=script&lang=js"
export * from "./ContactOverlay.vue?vue&type=script&lang=js"

import "./ContactOverlay.vue?vue&type=style&index=0&id=a7007144&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7007144"]])

export default __exports__